import { createHistory } from "@reach/router";
import qs from "query-string";

const history = createHistory(window);

export const { navigate } = history;
export const { location } = history;

export function clearQuery() {
  navigate(location.origin + location.pathname);
}

export function getQuery() {
  return qs.parse(location.search, {
    arrayFormat: "comma",
    parseBooleans: true
  });
}

export function setQuery(query) {
  navigate(`?${qs.stringify(query, { arrayFormat: "comma" })}`);
}

export function addQuery(param) {
  const query = getQuery();
  query[param] = param;
  setQuery(query);
}

export function removeQuery(param) {
  const query = getQuery();
  delete query[param];
  setQuery(query);
}

export default history;
